import { of } from 'rxjs';

import {
  actions as bootstrapActions,
  selectors as bootstrapSelectors,
} from '@ezugi/bootstrap';
import { uiActions } from '@ezugi/bootstrap/src/store/actions/ui';
import { isWelcomeDialogAvailable } from '@ezugi/bootstrap/src/util/isWelcomeDialogAvailable';
import { LOADING, GAME_ID_FROM_URL } from '@ezugi/constants';

import {
  NO_WELCOME_DIALOG,
  NO_WELCOME_DIALOG_ULTIMATE_SICBO,
  WELCOME_DIALOG,
} from '../../../constants/strings';
import { isUltimateSicBo } from '../../../utils';

const { showTutorialSelector } = bootstrapSelectors;
const {
  roundActions: { round },
  gameActions: { game },
  settingsActions: { settings },
  socketActions: { socket },
  betActions: { history, bet },
  dialogActions: { dialog },
} = bootstrapActions;

// current implementation doesn't provide support for auto sicbo (game id SICBO_AUTO_ID)
const noWelcomeDialogKey = isUltimateSicBo
  ? NO_WELCOME_DIALOG_ULTIMATE_SICBO
  : NO_WELCOME_DIALOG;

export default (socketMessage, state) => {
  const {
    roundId,
    timeStamp,
    RoundTripStartTime,
    playerBetOfThisRound,
    History,
    Stats,
    dynamicMultipliers,
  } = socketMessage;

  return of(
    socket.success(),
    settings.init(),
    round.set({
      roundStatus: LOADING,
      roundId,
      roundTime: RoundTripStartTime,
      timestamp: timeStamp,
    }),
    bet.update(
      playerBetOfThisRound.reduce(
        (acc, { betValue, index }) => {
          acc.current[index] = {
            value: betValue,
            valid: true,
          };
          acc.totalBet += betValue;

          return acc;
        },
        {
          totalBet: 0,
          current: {},
        }
      )
    ),
    game.set({
      history: History,
      stats: Stats,
      multipliers: dynamicMultipliers,
      gameResults: {
        winningBets: [],
      },
    }),
    uiActions.progressBar.reset(),
    history.reset(),
    ...(isWelcomeDialogAvailable({
      noWelcomeDialogKey,
      gameId: GAME_ID_FROM_URL,
      state,
    }) && showTutorialSelector(state)
      ? [ dialog.add({ name: WELCOME_DIALOG }) ]
      : [])
  );
};
